import React from 'react';
import {classes, st} from './CartBodySkeleton.st.css';
import {classes as cartSummaryClasses} from '../OrderSummary/CartSummarySkeleton/CartSummarySkeleton.st.css';
import {SkeletonLineWrapper} from '../../../../../common/components/Skeleton/SkeletonLine/SkeletonLineWrapper';
import {SkeletonSection} from '../../../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {Skeleton} from '../../../../../common/components/Skeleton/Skeleton';
import {SkeletonRow} from '../../../../../common/components/Skeleton/SkeletonRow/SkeletonRow';

export enum CartBodySkeletonDataHook {
  root = 'CartBodySkeleton.root',
}

export const CartBodySkeleton = () => {
  return (
    <Skeleton className={classes.skeleton} dataHook={CartBodySkeletonDataHook.root}>
      <SkeletonSection>
        <SkeletonRow className={classes.item}>
          <SkeletonLineWrapper className={classes.image} />
          <SkeletonSection className={classes.itemDetails}>
            <SkeletonSection>
              <SkeletonRow>
                <SkeletonLineWrapper size="medium" />
              </SkeletonRow>
              <SkeletonRow>
                <SkeletonLineWrapper size="large" />
              </SkeletonRow>
              <SkeletonRow>
                <SkeletonLineWrapper size="medium" />
              </SkeletonRow>
              <SkeletonRow>
                <SkeletonLineWrapper size="large" />
              </SkeletonRow>
              <SkeletonRow>
                <SkeletonLineWrapper size="small" />
              </SkeletonRow>
              <SkeletonRow>
                <SkeletonLineWrapper size="medium" />
              </SkeletonRow>
            </SkeletonSection>
            <SkeletonSection>
              <SkeletonRow className={classes.price}>
                <SkeletonLineWrapper size="medium" />
                <SkeletonLineWrapper size="small" />
              </SkeletonRow>
            </SkeletonSection>
          </SkeletonSection>
        </SkeletonRow>
      </SkeletonSection>
      <div className={cartSummaryClasses.divider} />
      <SkeletonSection>
        <SkeletonRow>
          <SkeletonLineWrapper size="large" />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper size="medium" />
        </SkeletonRow>
      </SkeletonSection>
      <div className={st(cartSummaryClasses.divider, classes.bottomDivider)} />
    </Skeleton>
  );
};
